import { useRequest } from "hooks/useRequest";

export const useStoresRequester = () => {
	const request = useRequest("store");

	return {
		...request,
	};
};
